export const getAccessPackageVariant = (
  pkg: string
): 'primary' | 'default' | 'warning' | 'success' | 'secondary' => {
  switch (pkg) {
    case 'premium':
      return 'primary';
    case 'trial':
      return 'warning';
    case 'verified':
      return 'success';
    case 'leadGen':
      return 'secondary';
    default:
      return 'default';
  }
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};
